import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { ITEM_ROOT } from "odata-query";
import { alertRequest, body, request } from "services/request";

const resource = "api/hiredCars";
const hiredCarsQuery = { orderBy: ["id desc"] };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...hiredCarsQuery });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};

const listForSelect = ({ counterpartyIds, ...params }: { counterpartyIds?: number[] } & OdataFilters) => {
    const query = containsQuery(
        params,
        counterpartyIds?.length
            ? {
                  filter: { counterpartyIds: { any: { [ITEM_ROOT]: counterpartyIds } } },
              }
            : {},
    );
    return request(`${resource}/getListForSelect${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const getItem = (params: { id: number }) => request(`${resource}/get/${params.id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

export { index, apply, getItem, delItem, restore, listForSelect };
